import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Hero from "../components/home/HeroSection";
import Countdown from "../components/home/Countdown";
import AboutSection from "../components/home/About";
import EventSchedule from "../components/home/ScheduleSection";
import TicketsSection from "../components/home/TicketsSection";
import MeetTheChef from "../components/home/MeetTheChef";
import Highlights from "../components/home/Highlights";
import VenueSection from "../components/home/VenueSection";
import ExperienceSection from "../components/home/ExperienceSection";
import MenuSummarySection from "../components/home/MenuSummarySection";

export default function Home() {
  const location = useLocation();

  useEffect(() => {
    if (location.state?.scrollTo) {
      const section = document.getElementById(location.state.scrollTo);
      if (section) {
        setTimeout(() => {
          section.scrollIntoView({ behavior: "smooth" });
        }, 100); // small delay so DOM is ready
      }
    }
  }, [location]);

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="">
      {/* <div className="block h-[10vh] bg-white"></div> */}
      <div id="home" className="bg-white pt-[10vh]">
        <Hero />
        <Countdown />
      </div>
      <div id="about" className="">
        <AboutSection />
      </div>
      <div id="experience" className="">
        {/* <ExperienceSection /> */}
        <ExperienceSection />
      </div>
      <div id="meet-the-chef" className="">
        <MeetTheChef />
      </div>
      <div id="highlights" className="">
        <Highlights />
      </div>
      <div id="schedule" className="">
        {/* <ScheduleSection /> */}
        <EventSchedule />
      </div>
      <div id="menu" className="">
        <MenuSummarySection />
      </div>
      <div id="venue" className="">
        <VenueSection />
      </div>
      <div id="tickets" className="">
        {/* <TicketsSection /> */}
        <TicketsSection />
      </div>
    </div>
  );
}
